import { Collapse } from "antd";
import styled from "styled-components";

export const ConditionCollapse = styled(Collapse)<{hidden: boolean}>`
  visibility: ${({ hidden }) => (hidden ? "hidden" : "visible")};
  height: ${({ hidden }) => (hidden ? "0px" : "auto")};
`;
